export const getBooleanQueryParam = (value: string | string[] | undefined | null): boolean => {
    if (Array.isArray(value)) {
        return false;
    }

    return value === 'true' || value === '1';
};
